import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// The production build renames public/locales to locales-<buildno> for cache-busting, so the
// path has to be derived at runtime from the build stamp in index.html. It cannot be baked into
// this bundle at build time: the bundle filename is a hash of its pre-stamp contents, so a build
// that changes no JS reuses the filename, and a cached copy would keep requesting a folder the
// next deploy has already removed — silently losing every translation.
//
// Locally there is no rename and the placeholder is served verbatim, so fall back to /locales.
const buildno = globalThis.__BUILD__?.buildno || "";
const localesDir =
  buildno && !buildno.startsWith("$") ? `locales-${buildno}` : "locales";

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to the react-i18next components.
  // Alternative use the I18nextProvider: https://react.i18next.com/components/i18nextprovider
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    load: "currentOnly",
    fallbackLng: "en-US",
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: `/${localesDir}/{{lng}}/translation.json`,
    },
  });

export default i18n;
